const UNSUPPORTED_CHANGE_TYPES = new Set([
  'date',
  'datetime',
  'time',
  'relativeDate',
  'bool',
  'boolean',
  'url',
]);

function metricSupportsChange(metric) {
  const type = metric?.type || 'number';
  return !UNSUPPORTED_CHANGE_TYPES.has(type);
}

function metricSupportsShareOfTotal(metric) {
  const type = metric?.type || 'number';
  return !UNSUPPORTED_CHANGE_TYPES.has(type) && !['max', 'min'].includes(metric?.aggregation);
}

module.exports = {
  metricSupportsChange,
  metricSupportsShareOfTotal,
};
